import React, { useState } from 'react';

import BulkTesterWidget from './BulkTester';
import IndividualTesterWidget from './IndividualTester';

import { Button } from '@asphalt-react/button';

const GenericUIMode = {
  INDIVIDUAL_TEST_MODE: 'INDIVIDUAL',
  BULK_TEST_MODE: 'bulk',
} as const;

type GenericUIMode = (typeof GenericUIMode)[keyof typeof GenericUIMode];

const GenericUI: React.FC = () => {
  const [uiMode, setUiMode] = useState<GenericUIMode>(
    GenericUIMode.INDIVIDUAL_TEST_MODE
  );

  return (
    <div className="flex justify-center">
      <div className="w-full rounded-lg shadow-lg p-4 ">
        <div className="flex gap-2 mb-4 w-full">
          <Button
            data-testid="individual-test-mode-button"
            size="xs"
            onClick={() => setUiMode(GenericUIMode.INDIVIDUAL_TEST_MODE)}
            primary={uiMode == GenericUIMode.INDIVIDUAL_TEST_MODE}
            secondary={uiMode != GenericUIMode.INDIVIDUAL_TEST_MODE}
          >
            Individual test
          </Button>
          <Button
            data-testid="bulk-test-mode-button"
            size="xs"
            onClick={() => setUiMode(GenericUIMode.BULK_TEST_MODE)}
            primary={uiMode == GenericUIMode.BULK_TEST_MODE}
            secondary={uiMode != GenericUIMode.BULK_TEST_MODE}
          >
            Bulk test
          </Button>
        </div>
        {uiMode == GenericUIMode.INDIVIDUAL_TEST_MODE && (
          <IndividualTesterWidget />
        )}

        {uiMode == GenericUIMode.BULK_TEST_MODE && <BulkTesterWidget />}
      </div>
    </div>
  );
};

export default GenericUI;
